<template>
    <v-dialog v-model="shows" width="500px">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title>취소 사유 생성</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-text-field v-model="form.subject" label="사유" outlined dense hide-details="auto" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer />
                <v-btn @click="() => (shows = false)">취소</v-btn>
                <v-btn color="primary" @click="save">생성</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: { text: String, default: "" },
        index: { text: Number, default: null },
    },
    data: () => ({
        shows: false,
        form: {
            subject: "",
        },
    }),
    computed: {
        isCreated() {
            return true;
        },
        isCreated() {
            return this.index !== 0 && !this.index;
        }
    },
    mounted() {
        this.sync();
    },
    methods: {
        sync() {
            this.form = { ...this.value, index: this.index };
        },
        save() {
            this.$emit("update", this.form);
            this.shows = false;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.sync();
        },
    },
};
</script>

<style>
</style>